<template>
  <f-project-tabs
    dnd-styles
    class="f-creator-tabs"
    @select="tabSelect($event)"
    v-if="Object.values(component.projects).length > 0"
    :tabs-count="tabs.length"
    :class="{ 'transparent-background': !currentProject }"
  >
    <template #default>
      <Container
        class=""
        @drop="(dropResult) => dropResult && onDrop(dropResult)"
        @drag-start="onDragging = true"
        @drag-end="onDragging = false"
        orientation="horizontal"
        group-name="f_tabs"
        lock-axis="x"
        drag-class="f-project-tabs-drag"
        :drop-placeholder="{ className: 'f-project-tabs-drop-placeholder' }"
      >
        <Draggable v-for="tab in tabs" :key="tab._key" class="tab-container">
          <f-project-tab
            :show-enabled="tab.enabled === true || tab.enabled === false"
            f-deletable
            :f-deletable-hide="onDragging"
            f-draggable-class
            v-bind="tab"
            @tabSelect="tabSelect(tab._key)"
            @delete="
              showTabDelete = {
                _key: tab._key,
                title2: component.delete_modal_title || huglyLegacyDeleteModalTitle,
              }
            "
          >
          </f-project-tab>

          <f-fade-transition>
            <f-modal-base
              closable
              v-if="(showTabDelete && showTabDelete._key) === tab._key"
              @close="showTabDelete = undefined"
              backdrop-close
              :title2="$vt(showTabDelete.title2)"
              :pending="showTabDeletePending"
            >
              <template #content>
                {{ $vt('Are you sure you want to remove') }} <strong> {{ tab.title }} </strong>?
              </template>
              <template #actions>
                <f-button type="tertiary" @click="showTabDelete = undefined"
                  >{{ $vt('Cancel') }}</f-button
                >
                <f-button
                  type="negative"
                  :pending="showTabDeletePending"
                  @click="tabDelete(tab)"
                  >{{ $vt('Remove') }}</f-button
                >
              </template>
            </f-modal-base>
          </f-fade-transition>
        </Draggable>
      </Container>
    </template>
    <template #new>
      <f-icon icon="fa6-plus"></f-icon>&nbsp;
      <span class="title" style="white-space: nowrap">{{
        $vt(component.add_label)
      }}</span></template
    >
    <template #info v-if="component.help_message">
      <Tippy arrow placement="left" max-width="500">
        <template v-slot:trigger>
          <f-icon icon="fa6-info"></f-icon>
        </template>

        <f-icon icon="fa6-circle-info" inline></f-icon>&nbsp;{{
          $vt(component.help_message)
        }}
      </Tippy>
    </template>
  </f-project-tabs>
</template>
<script>
import { debug } from "/vodalys/.jslibs";
const log = debug("FCreatorTabs");
import { Draggable, Container } from "/vodalys/vvuejs_lib_drag_n_drop";
export default {
  translate25Context: 'vcreator18',
  props: {
    component: Object,
    handler: Object,
    currentProject: String,
  },
  data() {
    return {
      onDragging: false,
      orderedKeys: undefined,
      showTabDelete: undefined,
      showTabDeletePending: false,
    };
  },
  components: { Draggable, Container },
  computed: {
    tabs() {
      let projectsMap = Object.entries(this.component.projects).map(
        ([key, project]) => {
          let icon;
          if (project.icon) {
            icon =
              project.icon.startsWith("fa-") ||
              project.icon.startsWith("fa6-") ||
              project.icon.startsWith("fg-")
                ? project.icon
                : "fa-" + project.icon;
          }

          let activeIcon;
          if (icon.startsWith("fg-")) {
            activeIcon = icon + "-turquoise";
          } else {
            activeIcon = icon;
          }

          return {
            _key: key,
            icon: icon || "fg-interactivity",
            activeIcon: activeIcon || "fg-interactivity-turquoise",
            active: this.currentProject === key,
            enabled: project.enabled,
            title: project.title,
            weight: project.weight,
          };
        }
      );

      return this.orderedKeys
        ? projectsMap.sort(
            (a, b) =>
              this.orderedKeys.indexOf(a._key) -
              this.orderedKeys.indexOf(b._key)
          )
        : projectsMap.sort((a, b) => a.weight - b.weight);
    },
    huglyLegacyDeleteModalTitle() {

      const {
        delete_modal_title, add_label
      } = this.component

      if (delete_modal_title) {
        // juste in case, ça evite de cacluler le regexp
        return delete_modal_title
      };

      if (/Add( a)?/.test(add_label)) {
        // On fait une derivation du add label, ça eviter de rentrer trop de text en dur
        return add_label.replace(/Add( a)?/, "Remove");
      }

      // et on garde le text d'origine en backup
      return 'Remove Input' // legacy text
    }
  },
  methods: {
    tabSelect: function (key) {
      this.activeProject = key;
      this.$emit("change", key);
      sessionStorage.setItem(`${this.component["#id"]}_activeProject`, key);
    },
    onDrop(args) {
      if (!args || !(typeof args.removedIndex == 'number') || !(typeof args.addedIndex == 'number')) {
        return;
      }

      let { removedIndex = undefined, addedIndex = undefined } = args;

      let orderedKeys = this.tabs.map((p) => p._key);

      let key = orderedKeys.splice(removedIndex, 1);
      orderedKeys.splice(addedIndex, 0, ...key);

      this.orderedKeys = orderedKeys;
      this.handler
        .action(this.component["#id"], "set_weights", [orderedKeys])
        .finally((_) => {
          this.orderedKeys = undefined;
        });

      this.i = 0;

      if (this.interval) {
        return;
      }

      this.interval = setInterval(async () => {
        if (this.i++ > 4) {
          clearInterval(this.interval);
          delete this.interval
          return;
        }
        const huglyFixResult = await this.cursorHuglyFix(this.i);
        if (huglyFixResult) {
          clearInterval(this.interval);
          delete this.interval
        }
      }, 500);
    },
    async cursorHuglyFix(i) {
      let styleElts = Array.from(document.querySelectorAll("style")).filter(
        (e) =>
          e.textContent === "body *{cursor:grab !important;}" ||
          e.textContent === "body *{cursor:auto !important;}"
      );
      if (styleElts && styleElts.length > 0) {
        log("cursor hugly fix find an hugly style", i, styleElts);
        styleElts.forEach((e) => {
          try {
            e.remove();
            log("cursor hugly fix done it's job",  e);
            return true;
          } catch (error) {
            log("oupsy on a broken le dnd");
          }
        });
      } else {
        log("cursor hugly fix has nothng hugly to do", i);
      }
    },
    async tabDelete(tab) {
      this.showTabDeletePending = true;

      const project = this.component.projects[tab._key];

      await this.handler.action(project["#id"], "delete");
      this.showTabDelete = undefined;
      this.showTabDeletePending = false;
    },
  },
  destroyed() {
    this.cursorHuglyFix();
  },
};
</script>
